import { Form, FormField, IFormField, RequiredValidator } from '@thinknimble/tn-forms'
import { SelectOption } from '../base-model'

export const accountTypeOptions: SelectOption[] = [
  { value: 'savings', label: 'Savings' },
  { value: 'checking', label: 'Checking' },
  { value: 'cash', label: 'Cash' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'debit_card', label: 'Debit Card' },
  { value: 'credit_line', label: 'Credit Line' },
]

export type CreatePaymentAccountFields = {
  _name: IFormField<string>
  organization: IFormField<SelectOption | undefined>
  user: IFormField<SelectOption | undefined>
  accountLastFour: IFormField<string>
  institution: IFormField<string>
  accountType: IFormField<SelectOption | undefined>
}

export class CreatePaymentAccountForm extends Form<CreatePaymentAccountFields> {
  static _name = new FormField({
    label: 'Account Name',
    placeholder: 'Enter account name',
    validators: [new RequiredValidator()],
  })

  static organization = new FormField({
    label: 'Organization',
    placeholder: 'Select an organization',
  })

  static user = new FormField({
    label: 'User',
    placeholder: 'Select a user',
  })

  static accountLastFour = new FormField({
    label: 'Last 4 Digits of Account',
    placeholder: 'Enter last 4 digits',
  })

  static institution = new FormField({
    label: 'Institution',
    placeholder: 'Enter institution name',
  })

  static accountType = new FormField({
    label: 'Account Type',
    placeholder: 'Select account type',
  })

  get val() {
    return {
      name: this.field._name.value,
      organization: this.field.organization.value?.value,
      user: this.field.user.value?.value,
      accountLastFour: this.field.accountLastFour.value,
      institution: this.field.institution.value,
      accountType: this.field.accountType.value?.value,
    }
  }
}

export type TCreatePaymentAccountForm = CreatePaymentAccountForm & CreatePaymentAccountFields
